import { MouseEvent, ReactNode, forwardRef, useState } from "react";

import { Button, ButtonProps, Popover, PopoverProps } from "@mui/material";

const NAME = "ButtonPopover";

export type ButtonPopoverProps = ButtonProps;

export const ButtonPopover = forwardRef<
  HTMLButtonElement,
  ButtonPopoverProps & {
    popover: ReactNode;
    popoverProps?: Partial<PopoverProps>;
  }
>(({ onClick, popover, popoverProps, ...buttonProps }, buttonRef) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    onClick?.(e);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button onClick={handleClick} ref={buttonRef} {...buttonProps} />
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        onClose={handleClose}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        {...popoverProps}
      >
        {popover}
      </Popover>
    </>
  );
});
ButtonPopover.displayName = NAME;
